<template>
  <div class="analise-visualizador">
    <div class="analise-visualizador__titulo">
      <v-layout style="align-items: center">
        <v-flex xs12 md8>
          <h2 >Análise de Documentação</h2>
        </v-flex>
      </v-layout>
    </div>

    <az-pdf-document-viewer :src="documento.url"
                            :height="tamanhoJanela.y + 'px'"
                            v-show="documento.url"
                            progress-bar
                            download-button
                            cssClass="analise-visualizador__documento"
                            @download="$emit('downloadDocumento', documento)"/>

    <p v-if="documento.url === null" class="mensagem-quando-vazio mt-2"></p>
  </div>

</template>

<script>

import {mapState} from "vuex";

export default {
  name: 'AnaliseDocumentacaoDemandaCredenciamentoFornecedor',
  props: {
    documento: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    tamanhoJanela: {
      x: 0,
      y: 0
    }
  }),
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  computed: {
    ...mapState(['licitacao']),
  },
  methods: {
    handleResize() {
      this.tamanhoJanela = {
        x: window.innerWidth,
        y: window.innerHeight - 60
      }
    },
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}

</script>

<style lang="stylus">
    .analise-visualizador__documento .az-pdf-toolbar__actions__more
        display none !important

    .analise-visualizador
        width 100%
        background-color #f8f9fa

        &__titulo
        padding 10px
            text-align left
            color #777
            font-size 16px
            border-bottom 1px solid #e9e9e9
            text-transform uppercase
            background-color #fff

        &__rodape
            position fixed
            bottom 0
            width 100%
            height 0px
            text-align center
            background-color #fff
            border-top 1px solid #eaeaea
            display flex
            align-items center
            justify-content center

            .sample:not(:last-child) {
                content: ' | ';
            }

            &-botao
                color #777
                padding 6px 20px

            &-botao:hover, &-botao:active, &-botao:focus
                background-color #f9f9f9

            &-mensagem
                margin-bottom 0
                color #7f7f7f
                font-size 13px

    @media (max-width 720px)
        .analise-visualizador
            &, &__rodape
                width 100%

            &__titulo
                padding-left 60px
                font-size 13px

    .mensagem-quando-vazio
        text-align center
</style>
